import { Model } from '../../../../../models/model';

export class EntryGroup extends Model<EntryGroup> {
  id: number;

  TenancyId: number;
  name: string;
  description: string;
}
